import { WebViewMessageObject } from 'types/react-native';

export const IS_NATIVE_APP = Boolean(window?.ReactNativeWebView);
export const NATIVE_APP_VERSION = window?.ReactNativeInfo?.version ?? '';

export const reactNativePostMessage = (object: Partial<WebViewMessageObject>) =>
  window?.ReactNativeWebView?.postMessage(JSON.stringify(object));
